var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCpeCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 16.449H35.9101V35.4018H31.9201V16.449Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.95 11.3919L9.96261 15.7203L19.95 19.5171L29.9373 15.7203L19.95 11.3919ZM19.95 7.26063L-0.1 15.9501L19.95 23.5723L39.9999 15.9501L19.95 7.26063Z",
    fill: "#0D1580"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4338 24.9717L26.4338 18.4441L30.2243 18.4441L30.2243 27.5022L19.9499 31.7682L9.67554 27.5021L9.67557 18.4441L13.4661 18.4441L13.4661 24.9717L19.9499 27.6639L26.4338 24.9717Z",
    fill: "#0D1580"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCpeCredits);
export default __webpack_public_path__ + "static/media/icon-cpe-credits.becb884bd88ae3489376436026bac250.svg";
export { ForwardRef as ReactComponent };